<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Template de e-mail</h3>
        </div>
      </div>

      <loader :is-loading="loadingPage"></loader>

      <div class="col-md-12 text-center text-sm-left template-email" v-if="!loadingPage">
        <d-card class="card">
          <d-card-body>
            <ValidationObserver tag="form" ref="TemplateValidationForm">
              <d-form-row>
                <!-- Code -->
                <d-col md="6" class="form-group">
                  <label>Código</label>
                    <d-form-input
                      type="text"
                      v-model="infoTemplate.Code"
                      :disabled="true"
                    />
                </d-col>
                <!-- Name -->
                <d-col md="6" class="form-group">
                  <label>Nome</label>
                  <ValidationProvider rules="required|min:3" v-slot="{errors, invalid}">
                    <d-form-input
                      type="text"
                      v-model="infoTemplate.Name"
                      :disabled="Boolean(isSeeing)"
                      :class="validatedTemplateForm | showValidateError(invalid)"
                    />
                    <div
                      class="invalid-feedback d-block"
                      v-if="validatedTemplateForm"
                    >{{ errors[0] }}</div>
                  </ValidationProvider>
                </d-col>
              </d-form-row>
              <d-form-row>
                <!-- Description -->
                <d-col md="6" class="form-group">
                  <label>Descrição</label>
                  <ValidationProvider rules="required|min:4" v-slot="{errors, invalid}">
                    <d-form-input
                      type="text"
                      :class="validatedTemplateForm | showValidateError(invalid)"
                      v-model="infoTemplate.Description"
                      :disabled="Boolean(isSeeing)"
                    />
                    <div
                      class="invalid-feedback d-block"
                      v-if="validatedTemplateForm"
                    >{{ errors[0] }}</div>
                  </ValidationProvider>
                </d-col>
                <!-- Subject -->
                <d-col md="6" class="form-group">
                  <label>Assunto</label>
                  <ValidationProvider rules="required|min:4" v-slot="{errors, invalid}">
                    <d-form-input
                      type="text"
                      :class="validatedTemplateForm | showValidateError(invalid)"
                      v-model="infoTemplate.Subject"
                      :disabled="Boolean(isSeeing)"
                    />
                    <div
                      class="invalid-feedback d-block"
                      v-if="validatedTemplateForm"
                    >{{ errors[0] }}</div>
                  </ValidationProvider>
                </d-col>
              </d-form-row>
              <!-- Tags -->
              <d-form-row>
                <d-col md="12" class="form-group">
                  <label>Tags</label>
                  <ValidationProvider rules="required|min:4" v-slot="{errors, invalid}">
                    <d-form-input
                      type="text"
                      :class="validatedTemplateForm | showValidateError(invalid)"
                      v-model="infoTemplate.Tags"
                      :disabled="Boolean(isSeeing)"
                    />
                    <div
                      class="invalid-feedback d-block"
                      v-if="validatedTemplateForm"
                    >{{ errors[0] }}</div>
                  </ValidationProvider>
                </d-col>
              </d-form-row>
              <!-- HTML -->
              <d-form-row>
                <d-col md="12" class="form-group">
                  <label>HTML</label>
                  <ValidationProvider rules="required|min:4" v-slot="{errors, invalid}">
                    <b-form-textarea
                      type="text"
                      rows="16"
                      :class="validatedTemplateForm | showValidateError(invalid)"
                      v-model="infoTemplate.HTML"
                      :disabled="Boolean(isSeeing)"
                    />
                    <div
                      class="invalid-feedback d-block"
                      v-if="validatedTemplateForm"
                    >{{ errors[0] }}</div>
                  </ValidationProvider>
                </d-col>
              </d-form-row>
              <d-form-row>
                <d-col md="12" class="form-group">
                  <label>Visualização</label>
                  <span v-html="infoTemplate.HTML">{{infoTemplate.HTML}}</span>
                </d-col>
              </d-form-row>
            </ValidationObserver>
          </d-card-body>
          <!-- Save Changes -->
          <d-card-footer v-if="(!Boolean(isSeeing) && newPage == true) || (!Boolean(isSeeing) && newPage == false)" class="border-top">
            <d-button
              size="sm"
              v-on:click.stop="SaveTemplate()"
              class="btn-accent ml-auto d-table mr-3"
            >
              <template v-if="!Boolean(isSeeing) && newPage == true">Adicionar</template>
              <template v-else-if="!Boolean(isSeeing) && newPage == false">Salvar</template>
            </d-button>
          </d-card-footer>
        </d-card>
      </div>
    </div>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
export default {
  name: "template-emails",
  data: function() {
    return {
      props: {
        query: {}
      },
      loadingPage: false,
      loadingAddUpdate: false,
      countFilter: 0,
      idTemplate: 0,
      pOpened: null,
      newPage: false,
      infoTemplate: {
        Code: null,
        Name: null,
        Description: null,
        Subject: null,
        HTML: null,
        Tags: null
      },
      isSeeing: false,
      validatedTemplateForm: false
    };
  },
  computed: {},
  watch: {},
  mounted() { 
    this.isSeeing = this.$route.query.isSeeing.toString() == "true";
    this.idTemplate = this.$route.params.idTemplateEmail;
    this.newPage = this.idTemplate == 0;
    this.GetTemplateEmail();
  },
  methods: {
    SaveTemplate: function() {
      this.validatedTemplateForm = true;

      this.$refs.TemplateValidationForm.validate().then(isValid => {
        if (isValid) {
          this.loadingAddUpdate = true;
          this.isSeeing = true;
          if (this.newPage == true) {
            // Add
            this.$store
              .dispatch("AddTemplateEmail", this.infoTemplate)
              .then(() => {
                this.$makeToast(
                  "O template foi cadastrado corretamente na base de dados",
                  "success",
                  "Template"
                );
              })
              .catch(error => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao criar o template",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.$router.push({
                  name: "template-emails"
                });
              });
          } else {
            // Update
            this.$store
              .dispatch("UpdateTemplateEmail", this.infoTemplate)
              .then(() => {
                this.$makeToast(
                  "Suas modificações foram salvas na base de dados",
                  "success",
                  "Template"
                );
              })
              .catch(error => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao atualizar o template",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.$router.push({
                  name: "template-emails"
                });
              });
          }
        }
      });
    },
    GetTemplateEmail: function() {
      if (this.idTemplate != 0) {
        this.loadingPage = true;
        this.$store
          .dispatch("GetTemplateEmail", { id: this.idTemplate })
          .then(response => {
            this.infoTemplate = response;
          })
          .catch(error => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao buscar o template",
              error
            );
          })
          .finally(() => {
            this.loadingPage = false;
          });
      }
    }
  }
};
</script>

<style scoped>
.template-email {
  padding-left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/templateEmail.vue